var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.667A6.667 6.667 0 016.667 0H136a4 4 0 014 4v129.333a6.667 6.667 0 01-6.667 6.667C59.695 140 0 80.305 0 6.667z",
    fill: "#105ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMobileLogo);
export default __webpack_public_path__ + "static/media/new-mobile-logo.2f86b326c486030c4725a61e0a6df515.svg";
export { ForwardRef as ReactComponent };